import React from 'react';
import { useHistory } from 'react-router-dom';
import { Table as TableStrap } from 'reactstrap';

const Table = (props) => {
  const { hover, grp, children, data, isLoading } = props;
  const history = useHistory();

  const handleRowClick = (id) => {
    if (hover) {
      if (grp) {
        history.push(`${hover.path}/${id}/${grp}`);
      } else {
        history.push(`${hover.path}/${id}`);
      }
    }
  };

  const hoverr = !!hover;

  return (
    <div className="table-responsive">
      <TableStrap hover={hoverr}>
        <thead>
          <tr>
            {React.Children.map(children, (child) => (
              <th
                style={
                  child.props.action && { width: '100px', minWidth: '100px' }
                }
              >
                {child.props.label ? child.props.label : ' '}
              </th>
            ))}
          </tr>
        </thead>
        <tbody>
          {!isLoading ? (
            data.length > 0 ? (
              data.map((item, index) =>
                hover ? (
                  <tr key={index} onClick={() => handleRowClick(item.id)}>
                    {React.Children.map(children, (child, index) => (
                      <td
                        key={index}
                        className={`align-middle ${
                          child.props.action && 'text-right'
                        }`}
                      >
                        {React.cloneElement(child, {
                          data: child.props.name
                            ? item[child.props.name]
                            : item,
                        })}
                      </td>
                    ))}
                  </tr>
                ) : (
                  <tr key={index}>
                    {React.Children.map(children, (child, index) => (
                      <td
                        key={index}
                        className={`align-middle ${
                          child.props.action && 'text-right'
                        }`}
                      >
                        {React.cloneElement(child, {
                          data: child.props.name
                            ? item[child.props.name]
                            : item,
                        })}
                      </td>
                    ))}
                  </tr>
                )
              )
            ) : (
              <tr>
                <td colSpan={React.Children.count(children)}>
                  Pas encore d&apos;éléments
                </td>
              </tr>
            )
          ) : (
            <tr>
              <td colSpan={React.Children.count(children)}>
                Chargement en cours...
              </td>
            </tr>
          )}
        </tbody>
      </TableStrap>
    </div>
  );
};

Table.defaultProps = {
  isLoading: false,
};

export default Table;
